import { render } from "./AcquisitionBasic.vue?vue&type=template&id=0196f3d5&scoped=true&ts=true"
import script from "./AcquisitionBasic.vue?vue&type=script&lang=ts"
export * from "./AcquisitionBasic.vue?vue&type=script&lang=ts"

import "./AcquisitionBasic.vue?vue&type=style&index=0&id=0196f3d5&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0196f3d5"]])

export default __exports__